import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { getAssetUrl } from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

import {
    Box,
    Button,
    Image,

    /* Hooks */
    useBreakpointValue,
    useDisclosure
} from '@salesforce/retail-react-app/app/components/shared/ui'

/* Styles */
import { useMyRewardsStyles } from '../styles/myRewardsStyles'

/* Icons */
import { RewardsLogoDesktop, RewardsLogoMobile } from '../../../components/icons'

/* Components */
import ResponsivePicture from '../../../components/responsive-picture'
import { AuthModal, useAuthModal } from '../../../hooks/use-auth-modal'

/* Hooks */
import { useHistory } from 'react-router-dom'
import { useOptimizely } from '../../../contexts/optimizely-context'

/* Utils */
import { renderComponentsSwitch } from '../../../components/optimizely/utils/contentRenderer'

const Banner = ({ customer }) => {
    const history = useHistory()
    const styles = useMyRewardsStyles()
    const isMobile = useBreakpointValue({ base: true, lg: false });
    const bannerStyle = styles?.components?.banner
    const authModal = useAuthModal()
    const { rewardPageBlock } = useOptimizely()

    const MainBanner = useMemo(() => {
        return rewardPageBlock?.MainBanner?.Expanded
    }, [rewardPageBlock])

    // This will fallback CMS
    const hardCodedData = {
        heroBanner: {
            mobileSrc: getAssetUrl('static/img/my-rewards/heroMobile.jpg'),
            tabletSrc: getAssetUrl('static/img/my-rewards/heroDesktop.jpg'),
            desktopSrc: getAssetUrl('static/img/my-rewards/heroDesktop.jpg'),
            alt: 'Rewards Hero Banner'
        },
        icon: getAssetUrl('static/img/my-rewards/arrow.svg'),
        title: MainBanner?.SubTitle || 'Become a <span class="highlighted highlighted-small white">part</span> of the greater',
        logo: {
            mobileSrc:  getAssetUrl('static/img/my-rewards/collectifDesktop.svg'),
            desktopSrc: getAssetUrl('static/img/my-rewards/collectifMobile.svg'),
            alt: 'Rewards Hero Banner Logo'
        },
        cta: {
            label: 'Join our Collectif',
            href: '/my-rewards'
        },
        signInLabel: 'Sign In'
    }

    return (
        <Box>
            <Box {...bannerStyle.container}>
                {isMobile ? (
                    rewardPageBlock?.LogoMedia?.Expanded?.Url ?
                    <Image src={rewardPageBlock?.LogoMedia?.Expanded?.Url} alt={rewardPageBlock?.LogoAltText} /> : <RewardsLogoMobile {...bannerStyle.logo} alt={rewardPageBlock?.LogoAltText} />
                ) : (
                    rewardPageBlock?.LogoMedia?.Expanded?.Url ?
                    <Image src={rewardPageBlock?.LogoMedia?.Expanded?.Url} alt={rewardPageBlock?.LogoAltText} /> : <RewardsLogoDesktop {...bannerStyle.logo} alt={rewardPageBlock?.LogoAltText} />
                )}
            </Box>

            {!customer.isRegistered &&
                <Box {...bannerStyle.heroContainer}>
                    <Box {...styles.overlay}></Box>
                    {MainBanner ? (
                        renderComponentsSwitch(MainBanner, {
                            overwriteWidgetTitleStyle: {
                                marginTop: {base: 0},
                                marginBottom: {base: '86px', lg: 6},
                                lineHeight: {base: '100%'}
                            },
                            overwriteWidgetTileCtaWrapperStyle: {
                                flexDirection: {base: 'column', lg: 'row'},
                                alignItems: {base: 'center'},
                                justifyContent: {base: 'center'}
                            }
                        })
                    ) : (
                        <>
                            <ResponsivePicture {...hardCodedData.heroBanner} imageProps={{ width: '100%' }} />
                            <Box {...bannerStyle.heroContent}>
                                <Box {...bannerStyle.titleWrapper}>
                                    <Image src={hardCodedData.icon} {...bannerStyle.arrowIcon} />
                                    <Box
                                        {...styles.sectionTitle}
                                        {...bannerStyle.title}
                                        sx={styles.highlighted}
                                        dangerouslySetInnerHTML={{ __html: hardCodedData.title }} />
                                </Box>
                                <ResponsivePicture {...hardCodedData.logo} imageProps={{ ...bannerStyle.heroLogo }} />
                                <Box {...bannerStyle.ctaContainer}>
                                    <Button variant='outline' {...bannerStyle.ctaButton} onClick={() => history.push(hardCodedData.cta.href)}>
                                        {hardCodedData.cta.label}
                                    </Button>
                                    <Button variant='link' {...bannerStyle.ctaLink} onClick={() => authModal.onOpen()}>
                                        {hardCodedData.signInLabel}
                                    </Button>
                                </Box>
                                <AuthModal {...authModal} />
                            </Box>
                        </>
                    )}
                </Box>
            }
        </Box>
    )
}

Banner.propTypes = {
    customer: PropTypes.object
}

export default Banner
